/* eslint-env browser */
import processShim from "../vendor/nodeProcessBrowser";

if (typeof window !== "undefined" && !window.process) {
  window.process = processShim;
}
